import React from 'react'
// import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { validateInputText } from '../../../utilities/ValidateUtil';
export default function P402Search2({ action,data,setData ,submitted }) {

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    return (
        <div className="p-fluid p-formgrid p-grid">

            <div className="p-field p-col-12 p-md-4">
                <label htmlFor="DOC_NAME">รหัสบริษัทคู่สัญญา</label>
                <InputText 
                    type="text" placeholder="รหัสบริษัทคู่สัญญา"
                    disabled={action.action==='แก้ไข'}
                    className={classNames({ "p-invalid": !(action.action==='แก้ไข') })}
                    value={data.contractorCode}
                    onChange={(e) => onInputTextChange(e, "contractorCode")} 
                    maxLength="20"
                
                />
                {submitted && !data.contractorCode && validateInputText('contractorCode', 'รหัสบริษัทคู่สัญญา')}
            </div>
            <div className="p-field p-col-12 p-md-4">
                <label htmlFor="DOC_NAME">ชื่อบริษัทคู่สัญญา</label>
                <InputText 
                    type="text" placeholder="ชื่อบริษัทคู่สัญญา"
                    className="p-invalid"
                    maxLength="200"
                    value={data.contractorName}
                    onChange={(e) => onInputTextChange(e, "contractorName")} 
                />
                {submitted && !data.contractorName && validateInputText('contractorName', 'ชื่อบริษัทคู่สัญญา')}
            </div>
            
        </div>
    )
}
